import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import SolidGauge from "highcharts/modules/solid-gauge";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";
import Accessibility from "highcharts/modules/accessibility";
import "../components/TeacherProficiencyStyle.css";
import { useTranslation } from "react-i18next";

// Initialize the required Highcharts modules
HighchartsMore(Highcharts);
SolidGauge(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);
Accessibility(Highcharts);

const TeacherProficiency = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const renderIcons = function () {
      this.series.forEach((series) => {
        if (!series.icon) {
          series.icon = this.renderer
            .text(
              `<i className="fa fa-${series.options.custom.icon}"></i>`,
              0,
              0,
              true
            )
            .attr({
              zIndex: 10,
            })
            .css({
              color: series.options.custom.iconColor,
              fontSize: "1.5em",
            })
            .add(this.series[2].group);
        }
        series.icon.attr({
          x: this.chartWidth / 2 - 15,
          y:
            this.plotHeight / 2 -
            series.points[0].shapeArgs.innerR -
            (series.points[0].shapeArgs.r - series.points[0].shapeArgs.innerR) /
              2 +
            8,
        });
      });
    };

    const trackColors = Highcharts.getOptions().colors.map((color) =>
      new Highcharts.Color(color).setOpacity(0.3).get()
    );

    Highcharts.chart("container", {
      chart: {
        type: "solidgauge",
        height: "50%",
        backgroundColor: null, // Set background to transparent
        events: {
          render: renderIcons,
        },
      },
      title: {
        text: "",
        style: {
          fontSize: "16px",
        },
      },

      tooltip: {
        borderWidth: 0,
        backgroundColor: "none",
        shadow: false,
        style: {
          fontSize: "12px",
        },
        valueSuffix: "%",
        pointFormat:
          "{series.name}<br>" +
          '<span style="font-size: 2em; color: {point.color}; ' +
          'font-weight: bold">{point.y}</span>',
        positioner: function (labelWidth) {
          return {
            x: (this.chart.chartWidth - labelWidth) / 17,
            y: this.chart.plotHeight / 2 - 10,
          };
        },
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [
          {
            // Track for Conversion
            outerRadius: "112%",
            innerRadius: "88%",
            backgroundColor: trackColors[0],
            borderWidth: 0,
          },
          {
            // Track for Engagement
            outerRadius: "87%",
            innerRadius: "63%",
            backgroundColor: trackColors[2],
            borderWidth: 0,
          },
          {
            // Track for Feedback
            outerRadius: "62%",
            innerRadius: "38%",
            backgroundColor: trackColors[3],
            borderWidth: 0,
          },
        ],
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false,
          },
          linecap: "round",
          stickyTracking: false,
          rounded: true,
        },
      },
      series: [
        {
          name: "Conversion",
          data: [
            {
              color: Highcharts.getOptions().colors[0],
              radius: "112%",
              innerRadius: "88%",
              y: 90,
            },
          ],
          custom: {
            icon: "filter",
            iconColor: "#303030",
          },
        },
        {
          name: "Engagement",
          data: [
            {
              color: Highcharts.getOptions().colors[2],
              radius: "87%",
              innerRadius: "63%",
              y: 80,
            },
          ],
          custom: {
            icon: "comments-o",
            iconColor: "#fff000",
          },
        },
        {
          name: "Feedback",
          data: [
            {
              color: Highcharts.getOptions().colors[3],
              radius: "62%",
              innerRadius: "38%",
              y: 60,
            },
          ],
          custom: {
            icon: "commenting-o",
            iconColor: "#303030",
          },
        },
      ],
    });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-12 d-flex row justify-content-start m-0">
          <div className="my-4 col-6 d-flex justify-content-between align-items-center">
            <h3 className="my-4" style={{ color: "#0b3c85" }}>
              {t("Proficiency")}
            </h3>
          </div>
          <h6 className="">{t("Detailed Proficiency Score")}</h6>

          <div className="container p-4 pt-4 d-flex column">
            <div>
              <figure className="highcharts-figure">
                <div id="container"></div>
              </figure>
            </div>

            <div
              className="details d-flex column "
              style={{ alignItems: "end" }}
            >
              <ul className="d-flex column">
                <li
                  style={{
                    backgroundColor: "#09a5ff",
                    height: "7vh",
                    width: "0.5rem",
                    borderRadius: "15px",
                  }}
                ></li>
                <li className="mx-2">
                  {t("Deep Knowledge of Subject")}
                  <ul>
                    <li>90%</li>
                  </ul>
                </li>
              </ul>
              <ul className="d-flex column">
                <li
                  style={{
                    backgroundColor: "#00c000",
                    height: "7vh",
                    width: "0.5rem",
                    borderRadius: "15px",
                  }}
                ></li>
                <li className="mx-2">
                  {t("Inter Personal Skills")}
                  <ul>
                    <li>80%</li>
                  </ul>
                </li>
              </ul>
              <ul className="d-flex column">
                <li
                  style={{
                    backgroundColor: "#ff5f2e",
                    height: "7vh",
                    width: "0.5rem",
                    borderRadius: "15px",
                  }}
                ></li>
                <li className="mx-2">
                  {t("Leadership And Initiative")}
                  <ul>
                    <li>60%</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div className="container p-4 pt-4 d-flex row mt-4">
          <h6 className="">{t("Detailed Proficiency Score")}</h6>
            <div
              className="details d-flex column col-12 mt-4"
              style={{ alignItems: "end" , justifyContent:"space-between"}}
            >
            
              <ul className="d-flex column">
                <li
                  style={{
                    backgroundColor: "#09a5ff",
                    height: "7vh",
                    width: "0.5rem",
                    borderRadius: "15px",
                  }}
                ></li>
                <li className="mx-2">
                  {t("Teaching Technique Skills")}
                  <ul>
                    <li>90%</li>
                  </ul>
                </li>
              </ul>
              <ul className="d-flex column">
                <li
                  style={{
                    backgroundColor: "#00c000",
                    height: "7vh",
                    width: "0.5rem",
                    borderRadius: "15px",
                  }}
                ></li>
                <li className="mx-2">
                  {t("Communication Skills")}
                  <ul>
                    <li>80%</li>
                  </ul>
                </li>
              </ul>
              <ul className="d-flex column">
                <li
                  style={{
                    backgroundColor: "#ff5f2e",
                    height: "7vh",
                    width: "0.5rem",
                    borderRadius: "15px",
                  }}
                ></li>
                <li className="mx-2">
                  {t("SUbject Matter Expertise")}
                  <ul>
                    <li>60%</li>
                  </ul>
                </li>
              </ul>
              <ul className="d-flex column">
                <li
                  style={{
                    backgroundColor: "#ff5f2e",
                    height: "7vh",
                    width: "0.5rem",
                    borderRadius: "15px",
                  }}
                ></li>
                <li className="mx-2">
                  {t("Technological Proficiency")}
                  <ul>
                    <li>60%</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherProficiency;
